// @flow

export default class Store {
    track(eventName: string, metadata?: { [key: string]: any }) {
        this.constructor.track(eventName, metadata);
    }

    static track(eventName: string, metadata?: { [key: string]: any }) {
    }
}



// WEBPACK FOOTER //
// ./src/app/stores/Store.js